export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',

  // ===== Common =====
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.action': 'Action',
  'common.delete': 'Delete',
  'common.deleted': 'Deleted',
  'common.deleteFailed': 'Delete failed',
  'common.refresh': 'Refresh',
  'common.create': 'Create',
  'common.createSuccess': 'Created successfully',
  'common.edit': 'Edit',
  'common.save': 'Save',
  'common.saveSuccess': 'Saved successfully',
  'common.operationFailed': 'Operation failed',
  'common.optional': 'Optional',

  // ===== AI Models =====
  'pages.system.aiModels.title': 'AI Models',
  'pages.system.aiModels.table.id': 'ID',
  'pages.system.aiModels.table.name': 'Name',
  'pages.system.aiModels.table.publicId': 'Public Model ID',
  'pages.system.aiModels.table.modelId': 'Provider Model ID',
  'pages.system.aiModels.table.endpointUrl': 'Endpoint',
  'pages.system.aiModels.table.apiKey': 'API Key',
  'pages.system.aiModels.apiKey.empty': 'Not set',
  'pages.system.aiModels.table.reasoningMode': 'Reasoning mode',
  'pages.system.aiModels.table.enabled': 'Enabled',
  'pages.system.aiModels.table.updatedAt': 'Updated At',
  'pages.system.aiModels.reasoningMode.none': 'None',
  'pages.system.aiModels.reasoningMode.optional': 'Optional',
  'pages.system.aiModels.reasoningMode.required': 'Required',
  'pages.system.aiModels.confirmDelete': 'Delete this model config?',
  'pages.system.aiModels.note':
    'Note: Data comes from backend-worker D1 (/api/system/ai/models), used to manage AI models and routing; the public model ID is an auto-generated UUID.',
  'pages.system.aiModels.modal.editTitle': 'Edit Model',
  'pages.system.aiModels.modal.createTitle': 'Create Model',
  'pages.system.aiModels.fetchAvailable': 'Fetch available models',
  'pages.system.aiModels.fetchAvailableSuccess': 'Fetched available models',
  'pages.system.aiModels.fetchAvailableFailed':
    'Failed to fetch models. Check backend AI settings.',
  'pages.system.aiModels.form.name.label': 'Display name',
  'pages.system.aiModels.form.name.placeholder': 'e.g. OpenAI GPT-4o mini',
  'pages.system.aiModels.form.publicId.label': 'Public Model ID',
  'pages.system.aiModels.form.publicId.extra':
    'Auto-generated after creation for client requests.',
  'pages.system.aiModels.form.publicId.placeholder':
    'Auto-generated after creation',
  'pages.system.aiModels.form.modelId.label': 'Provider Model ID',
  'pages.system.aiModels.form.reasoningMode.label': 'Reasoning mode',
  'pages.system.aiModels.form.modelId.placeholder': 'e.g. gpt-4o-mini',
  'pages.system.aiModels.form.modelId.extra':
    'You can also pick one from the fetched list.',
  'pages.system.aiModels.form.modelId.extraEmpty':
    'You can type manually. If backend AI_OPENAI_* is configured, click “Fetch available models” to assist selection.',
  'pages.system.aiModels.form.endpointUrl.label': 'Endpoint',
  'pages.system.aiModels.form.endpointUrl.extra':
    'Fill in the provider chat-completions endpoint, or its base URL (will append /chat/completions).',
  'pages.system.aiModels.form.endpointUrl.placeholder':
    'e.g. https://api.openai.com/v1/chat/completions',
  'pages.system.aiModels.form.apiKey.label': 'API Key',
  'pages.system.aiModels.form.apiKey.placeholder': 'e.g. sk-***',
  'pages.system.aiModels.form.enabled.label': 'Enabled',

  // ===== Software Updates =====
  'pages.system.update.title': 'Software Updates',
  'pages.system.update.table.id': 'ID',
  'pages.system.update.table.appId': 'App',
  'pages.system.update.table.version': 'Version',
  'pages.system.update.table.force': 'Force',
  'pages.system.update.table.downloadUrl': 'Download URL',
  'pages.system.update.table.createdAt': 'Created At',
  'pages.system.update.confirmDelete': 'Delete this update?',
  'pages.system.update.note':
    'Note: Data comes from backend-worker D1 (/api/system/update/list).',
  'pages.system.update.modal.createTitle': 'Create Update',
  'pages.system.update.createFailedInvalidJson':
    'Create failed (logsJson must be valid JSON)',
  'pages.system.update.form.appId.label': 'App ID',
  'pages.system.update.form.appId.placeholder': 'e.g. skydimo',
  'pages.system.update.form.version.label': 'Version',
  'pages.system.update.form.version.placeholder': 'e.g. 1.2.3',
  'pages.system.update.form.commitId.label': 'Commit ID',
  'pages.system.update.form.downloadUrl.label': 'Download URL',
  'pages.system.update.form.createdAt.label':
    'Created At (schedule availability)',
  'pages.system.update.form.createdAt.tooltip':
    'Leave empty to use server time. If set to a future time, /api/update/check and /api/latest will not return this update until that time.',
  'pages.system.update.form.force.label': 'Force update',
  'pages.system.update.form.logsJson.label': 'Release notes (JSON)',
  'pages.system.update.form.logsJson.tooltip':
    'Backend expects Record<string, string>, e.g. {"zh-CN":"...","en-US":"..."}',

  // ===== Blog Management =====
  'pages.system.blog.title': 'Blog Management',
  'pages.system.blog.table.id': 'ID',
  'pages.system.blog.table.uuid': 'UUID',
  'pages.system.blog.table.published': 'Published',
  'pages.system.blog.table.coverUrl': 'Cover URL',
  'pages.system.blog.table.createdAt': 'Created At',
  'pages.system.blog.table.updatedAt': 'Updated At',
  'pages.system.blog.confirmDelete': 'Delete this post?',
  'pages.system.blog.note':
    'Note: Data comes from backend-worker D1 (/api/system/blog/list).',
  'pages.system.blog.modal.createTitle': 'Create Post',
  'pages.system.blog.createFailedInvalidJson':
    'Create failed (titles/contents must be valid JSON)',
  'pages.system.blog.form.uuid.label': 'UUID',
  'pages.system.blog.form.coverUrl.label': 'Cover URL',
  'pages.system.blog.form.published.label': 'Published',
  'pages.system.blog.form.createdAt.label': 'Created At (schedule publish)',
  'pages.system.blog.form.createdAt.tooltip':
    'Leave empty to use server time. If set to a future time, public /api/blog/list and /api/blog/detail will not return this post until that time.',
  'pages.system.blog.form.titlesJson.label': 'Titles (JSON)',
  'pages.system.blog.form.contentsJson.label': 'Contents (JSON)',
};
